const chatData = [
    {
        id: 1,
        image: 'assets/images/users/avatar-2.jpg',
        name: 'Frank Vickery',
        message: 'Hey! there I\'m available',
        time: '04 min',
        status: 'online'
    },
    {
        id: 2,
        image: 'assets/images/users/avatar-3.jpg',
        name: 'Robert Winter',
        message: 'I\'ve finished it! See you so',
        time: '09 min',
        status: 'intermediate'
    },
    {
        id: 3,
        name: 'Crystal Elliott',
        message: 'This theme is awesome!',
        time: '21 min',
        status: 'online'
    },
    {
        id: 4,
        image: 'assets/images/users/avatar-4.jpg',
        name: 'Kristen Steele',
        message: 'Nice to meet you',
        time: '1 hr',
        status: 'offline'
    },
    {
        id: 5,
        name: 'Mitchel Givens',
        message: 'Hey! there I\'m available',
        time: '3 hrs',
        status: 'intermediate'
    },
    {
        id: 6,
        image: 'assets/images/users/avatar-6.jpg',
        name: 'Stephen Hadley',
        message: 'I\'ve finished it! See you so',
        time: '5 hrs',
        status: 'online'
    },
    {
        id: 7,
        image: 'assets/images/users/avatar-2.jpg',
        name: 'Tracy Penley',
        message: 'This theme is awesome!',
        time: '24/03',
        status: 'online'
    },
];


const chatMessagesData = [
    {
        id: 1,
        name: 'Frank Vickery',
        message: 'Hey! I am available',
        image: 'assets/images/users/avatar-2.jpg',
        time: '12:09'
    },
    {
        id: 2,
        align: 'right',
        name: 'Ricky Clark',
        message: 'Hi, How are you? What about our next meeting?',
        time: '10:02'
    },
    {
        text: 'Today'
    },
    {
        id: 3,
        name: 'Frank Vickery',
        message: 'Hello!',
        image: 'assets/images/users/avatar-2.jpg',
        time: '10:06'
    },
    {
        id: 4,
        name: 'Frank Vickery',
        message: '& Next meeting tomorrow 10.00AM',
        image: 'assets/images/users/avatar-2.jpg',
        time: '10:06'
    },
    {
        id: 5,
        align: 'right',
        name: 'Ricky Clark',
        message: 'Wow that\'s great',
        time: '10:07'
    }
];

export { chatData, chatMessagesData };
